import React from 'react';
import PropTypes from 'prop-types';
// Components
import EventCard from './event-card';
import { dateAsString } from '../../utils/dates';
import { CardWrapper } from './styles';
import {
  registerPreprocessor,
  PREPROCESSOR_TYPES,
} from '../assemblies/preprocess';

registerPreprocessor(PREPROCESSOR_TYPES.GROUP, {
  test: (assembly) => assembly.internal?.type === 'ContentfulBlockCardEvent',
  name: 'CardWrapper',
  component: CardWrapper,
});

export const EventCardAssembly = ({ contentfulData }) => {
  const { event } = contentfulData;

  if (!event) return null;

  const date =
    event.eventDisplayDate || dateAsString(event.eventSystemDate, 'DD/M/YYYY');
  const link = contentfulData.primaryCtaLink || contentfulData.event?.link;

  return (
    <EventCard
      name={event.eventName}
      location={event.displayLocation}
      date={date}
      thumbnailImage={event.thumbnailImage}
      text={contentfulData.cardText}
      ctaText={contentfulData.primaryCtaText}
      ctaLink={link}
    />
  );
};

EventCardAssembly.propTypes = {
  contentfulData: PropTypes.object,
};

export default EventCardAssembly;
